import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { SABISDynamicformComponent } from "sabis-dynamicform";
import { FileHandler, UploadFileResult } from "sabis-dynamicform-core/cjs/Models/Options";
import { CareersUploader } from '../../../core/file-uploaders/careeers-fileuploader.service';
import { Guid } from "../../../settings/recruitment-steps/recruitment-steps.service";

@Injectable({
  providedIn: 'root'
})
export class FormInstanceService {

  constructor(private _http: HttpClient, @Inject('API_URL') private _apiUrl: string) { }

  public validate(formEditor: SABISDynamicformComponent): boolean {
    if (!formEditor.getFormInstance()!.validate()) {
      alert('Some fields are not valid');
      return false;
    }

    //if (formEditor.isUploading()) {
    //  alert('Please wait until all files are uploaded');
    //  return false;
    //}

    return true;
  }

  public createFileHandler(path: string, uploader: CareersUploader): FileHandler {
    let uploadFile: (file: any, progressCallback: (progressEvent: ProgressEvent) => void, completedCallback: (data: UploadFileResult) => void) => void =
      (file, progressCallback, completedCallback) => {

        let abortController: AbortController = new AbortController();
        let fileName: string = (file as File).name;
        let filePath: string = path + '/' + Guid.newGuid();
        let totalFile: number = (file as File).size;

        uploader.uploadFile(file, filePath, fileName, abortController.signal, (p => {
          let uploadedBytes = (p.uploadedPercentage / 100) * totalFile;
          let event: ProgressEvent = new ProgressEvent('progress', { lengthComputable: true, loaded: uploadedBytes, total: totalFile });
          progressCallback(event);
        }), (r) => {
          completedCallback(r);
        });
      };

    return {
      removeFile: () => { },
      uploadFile: uploadFile
    };
  }
}
